import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";
import { UpdatePersonalDataType } from "types/UsersTypes";

export const useUpdatePersonalData = (
  options?: UseMutationOptions<any, Error, UpdatePersonalDataType>
) => {
  return useMutation({
    mutationKey: ["updatePersonalData"],
    mutationFn: async (values: UpdatePersonalDataType) => {
      return axiosInstance
        .patch(
          `users/personal-data${values.uuid ? "/" + values.uuid : ""}`,
          values
        )
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "updatePersonalData",
      });

      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Zaktualizowano użytkownika",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "updatePersonalData",
      });
      queryClient.prefetchQuery({ queryKey: ["me"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error: any, variables, context) => {
      Toast({
        message: "Nie uda się zapisać zmian. Spróbuj ponownie",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "updatePersonalData",
      });

      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
